$(".AdditionalTeaserLinkPanel > a").on("click",
    function() {
        scrollTo("#AdditionalTeaser", function () { });
    });